import request from '@/utils/request'

export default {
  /**
   * 获取开台记录列表
   */
  getDeskOpens(params) {
    return request.get('/desk-opens', {
      params
    })
  },

  /**
   * 获取开台记录详情
   */
  getDeskOpensDetail(id) {
    return request.get(`/desk-opens/${id}/detail`)
  },

  /**
   * 获取出品过的商品信息
   */
  getDeskOpenProducts(id, params) {
    return request.get(`/desk-opens/${id}/order-products`, {
      params
    })
  }
}
